import { isProductUnavailable } from "../../utils/productUtils";
import getRuntimeConstants from "../runtimeConstants";
import makeRequest from "./makeRequest";
import { getAuthorisationHeader } from "../utils/identity";

export default async function getClientStockPrice({ products, storeCode }) {
  if (!products?.length || !storeCode) return [];

  const availableProducts = products.filter(
    (product) => !isProductUnavailable(product, storeCode)
  );

  if (!availableProducts.length) return [];

  const {
    webContext: {
      browseCurrency,
      browseCountry,
      keyStoreDataversion,
      browseLanguage,
      storeId,
    },
    stockPriceUrl,
    stockPriceApiTimeout,
  } = getRuntimeConstants();

  const url = `${stockPriceUrl}${availableProducts
    .map((product) => product.id)
    .join(",")}`;

  const params = {
    currency: browseCurrency,
    keyStoreDataversion,
    lang: browseLanguage,
    store: storeId,
    country: browseCountry,
  };

  const authorisationHeader = await getAuthorisationHeader();

  return makeRequest({
    url,
    params,
    timeout: stockPriceApiTimeout,
    apiName: "StockPrice",
    caller: "ClientStockPrice",
    headers: {
      authorisationHeader,
    },
    handleErrorReturnValue: () => [],
  });
}
